import React, { useState,useEffect } from "react";
//import { useNavigate } from "react-router-dom";
import Image from "../Image/Image";
import { useSelector } from "react-redux";
import Benefit from "../../LandingPage/BenefitPopup";
import ChangeNwPopUp from "../../ChangeNetwork/ChangeNwPopUp";
import { useAppContent } from "../../../shared/AppContent";
import { appNavigateTo } from "../../../store/actions/navActions";
import { useDispatch } from "react-redux";
import { funcSaveOnlyUserDetails } from "../../../store/actions/UserAction";
import {
  funcGetSelectedCardData, funcUpdateCurrentAppState, funcHandleGenericError
} from "../../../store/actions/AppStateActions";
import {
  trackPages,
  isAccountValidated,
  getUserNameOnCard,
  IsChangeCardVisible,
  getLightColorCard
} from "../../../shared/utility";

import { isVerticalCard, getSelectedCardtypeNwDetails, isFFNCard } from "../../../shared/SharedUtility";


const SidePanel = ({ getSection, goTo, classes, /*userDetail*/ }) => {
  const dispatch = useDispatch();
  const updateState = (currentAction, screenName) => dispatch(funcUpdateCurrentAppState(currentAction, screenName));
 // const navigate = useNavigate();
  const cardType = useSelector(state => state.AppState?.cardListDetails?.cardType);
  const productType = useSelector(state => state.AppState?.cardListDetails?.productType);
  const { leftSectionContent, applicationSubmissionContent } = useAppContent();
  const [isOpen, setPopOpen] = useState(false);
  const [isNwPopUpOpen,setNwPopOpen] = useState(false);
  const verticalCard = isVerticalCard(cardType);
  const ffnCard = isFFNCard(cardType);
  const lightcolorCard = getLightColorCard(cardType); 
  const currentAppState = useSelector((state) => state.AppState);
  const nwData = useSelector(state => state.CardDetails?.nwList);
  const imageUrl = useSelector((state) =>
    state.AppState?.cardListDetails?.frontImage
      ? state.AppState.cardListDetails.frontImage
      : ""
  );
  const cardActName = useSelector((state) =>
    state.AppState?.cardListDetails?.name 
      ? (state.AppState.cardListDetails.name )
      : "Air India SBI Signature Card"
  );
  const funcHandleError = (isGenericError, handleClick, exitEvent, errorMessage) =>
  dispatch(funcHandleGenericError(isGenericError, handleClick, exitEvent, errorMessage));
  const networkName = useSelector( (state) => state.AppState?.cardListDetails?.networkName);
  const userDetail = useSelector((state) => state.User.UserDetail);
  const [network,setNetworkName] = useState(userDetail?.currentNwType ? userDetail?.currentNwType : networkName);
  var currentpage = useSelector((state) => state.AppNav);
  const cardDetail = useSelector((state) => state.AppState.cardListDetails);
  const ckycData = useSelector((state) => state.SSL.ckycData);
  const selectedNwCardType = useSelector(state => state.CardDetails.selectedNwCardType);
  //const selctedCardTypeOption = nwData.filter( (card) => (card.cardType === cardType))?.[0];//fetching product type of selected card type
  const nwNameArr = nwData ? nwData.filter( (card) => card.productType === productType) : [];//fetching all card type of slected product type
  currentpage = currentpage?.goTo;
  useEffect( () => {
  if(userDetail?.currentNwType)
   setNetworkName(userDetail.currentNwType);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[userDetail.currentNwType]);

  useEffect(() => {
    if(currentAppState.currentAction === "ChangeNetwork") {
      updateState("NwUpdated");
      trackPages("tracking_148");
      handleChangeNwClose();
      currentAppState?.isGenericError && funcHandleError(false, null, null, '');
    }  
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [currentAppState]);

  const retrieveApplication = () => {
    trackPages("tracking_10");
    dispatch(appNavigateTo({ goTo: "personalDetails" }, "APP_NAVIGATE_TO"));
  };
  useEffect( () => {
    if(selectedNwCardType && selectedNwCardType !== "undefined" && selectedNwCardType !== "null" ) {
      let selectedProduct =  getSelectedCardtypeNwDetails(nwData, selectedNwCardType);
      if(selectedProduct && selectedProduct.productType === currentAppState.cardListDetails.productType) {
        dispatch(funcSaveOnlyUserDetails({ ...userDetail, cardType: selectedNwCardType  }));
        dispatch(funcGetSelectedCardData(currentAppState.cardList, selectedProduct.productType, "productType"));
        
      }else{
        dispatch(funcSaveOnlyUserDetails({ ...userDetail, cardType: selectedNwCardType, currentNwType: selectedProduct.network  }));
      }
      setNetworkName(selectedProduct.network);
      
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[selectedNwCardType])

  const togglePopup = () => {
    if (!isOpen) trackPages("tracking_6");
    // trackPages("tracking_28");
    setPopOpen(!isOpen);
  };

  const checkForPath = () => {
    if (
      goTo === "penydrop" ||
      goTo === "account" ||
      goTo === "credit" ||
      goTo === "debit" ||
      goTo === "validateOTP" ||
      goTo === "takePhoto" ||
      goTo === "penySuccess"
    ) {
      return true;
    } else {
      return false;
    }
  };
  
 
  const handleChangeNwClose = () => {
    setNwPopOpen(false);
  }
  return (
    <>
      <div className={classes.CardContainer}>
        {goTo === "validateOTP" ? (
          <div className={`${classes.CardChoice} ${classes.CompletionMsg}`}>
            {/* You are almost there! */}
            {applicationSubmissionContent?.lhs_details?.heading}
          </div>
        ) : isAccountValidated(goTo) ? (
          <div className={`${classes.CardChoice} ${classes.CompletionMsg}`}>
            {applicationSubmissionContent?.lhs_details?.heading}
          </div>
        ) : (
          <div className={classes.CardChoice}>{leftSectionContent?.heading}</div>
        )}
        <div className={classes.CardImage}>
          <Image
            filename={verticalCard ? "Group -6" : "Group 1722"}
            ext="png"
            renditions={["2x"]}
            className={verticalCard ? classes.backTile2Vertical : classes.backTile2}
            alt=""
          />
          {checkForPath() ? (
            cardDetail?.image && (
              <>
                <img
                  src={`${window.location.origin}${cardDetail?.frontImage}`}
                  className={verticalCard ? classes.frontImageVertical : classes.frontImage}
                  alt=""
                />
                <div className={ffnCard ? classes.cardUserNameFFN : verticalCard &&  lightcolorCard ? classes.verticalLightCardUserName : verticalCard ? classes.cardUserNameVertical :  lightcolorCard ? classes.lightCardUserName : classes.cardUserName} >
                  {getUserNameOnCard(userDetail)}
                </div>
              </>
            )
          ) : (
            <>
              <img
                src={`${window.location.origin}${imageUrl}`}
                className={verticalCard ? classes.frontImageVertical : classes.frontImage}
                alt=""
              />
              <div className={ffnCard ? classes.cardUserNameFFN : verticalCard &&  lightcolorCard ? classes.verticalLightCardUserName : verticalCard ? classes.cardUserNameVertical :  lightcolorCard ? classes.lightCardUserName : classes.cardUserName}>
                {getUserNameOnCard(userDetail)}
              </div>
            </>
          )}
        </div>
        <div className={classes.CardName}>{cardActName + " on " + network}</div>
        <div className={classes.CheckCard}>
          {getSection !== "kycDetails" &&
            IsChangeCardVisible(userDetail, ckycData?.applicationNumber,productType) && (
              <span
                onClick={() => {
                  trackPages("tracking_7");
                  dispatch(
                    appNavigateTo(
                      { goTo: "changecard", previouspage: currentpage },
                      "APP_NAVIGATE_TO"
                    )
                  );
                }}
              >
                <label className={`${classes.CardInfoIcon}`}>
                  {leftSectionContent?.changeCard_container?.label}
                </label>
                <Image
                  className={classes.ChangeCardArrow}
                  filename={"Path426"}
                  ext="png"
                  renditions={["2x"]}
                  alt=""
                />
              </span>
  

            )}
            <span
            onClick={togglePopup}
            className={
              getSection !== "kycDetails" &&
                IsChangeCardVisible(userDetail, ckycData?.applicationNumber,"")
                ? classes.ViewBenefits
                : ""
            }
          >
            <label className={`${classes.CardInfoIcon}`}>
              {leftSectionContent?.viewBenefitText}
            </label>
            <Image
              className={classes.ViewBenefitsArrow}
              filename={"Path426"}
              ext="png"
              renditions={["2x"]}
              alt=""
            />
          </span>
          {
            <div
              onClick={() => retrieveApplication()}
              className={
                goTo === "landingPage" &&
                  userDetail.firstName === "" &&
                  userDetail.mobileNo === ""
                  ? classes.ViewBenefits
                  : classes.VisibilityNone
              }
            >
              <label
                className={`${classes.CardInfoIcon} ${classes.ActiveLink} ${classes.RetrieveApp}`}
              >
                {leftSectionContent?.retrieveApplicationText}
              </label>
              <Image
                className={`${classes.ViewBenefitsArrow}  ${classes.ActiveLink}`}
                filename={"Path426"}
                ext="png"
                renditions={["2x"]}
                alt=""
              />
            </div>
          }
            {
              ((ckycData?.applicationNumber === undefined) || (ckycData?.applicationNumber === "")) && (<div
              onClick={() => {
                setNwPopOpen(true);
              }}
            >
              <label className={`${classes.CardInfoIcon}`}>
                {leftSectionContent?.changeCard_container?.changeNetworkText}
              </label>
              <Image
                className={classes.ChangeCardArrow}
                filename={"Path426"}
                ext="png"
                renditions={["2x"]}
                alt=""
              />
            </div>)
            }
          
         
        </div>
        <div
          className={`${classes.CardSectionImg} ${classes.leftPannelImage} ${classes[goTo]}`}
        >
          <Image
            filename={
              goTo
            }
            ext="png"
            renditions={["2x"]}
            alt=""
          />
        </div>
      </div>
      {isOpen && <Benefit classes={classes} togglePopup={togglePopup} />}
      {isNwPopUpOpen && <ChangeNwPopUp nwData={nwNameArr}  handleChangeNwClose={handleChangeNwClose}/>}
    </>
  );
};

export default SidePanel;
